import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import dialogReducer from '@/features/dialogSlice'
import dialogVisualReducer from '@/features/dialogVisualSlice'
import dialogStampFinishReducer from '@/features/dialogStampFinishSlice'
import dialogCouponReducer from '@/features/dialogCouponSlice'
import dialogGroupSpotsReducer from '@/features/dialogGroupSpotsSlice'
import dialogRewardsGetReducer from '@/features/dialogRewardsGetSlice'
import dialogRewardsFinishReducer from '@/features/dialogRewardsFinishSlice'
import dialogRewardsComfirmReducer from '@/features/dialogRewardsComfirmSlice'
import dialogRewardsResultReducer from '@/features/dialogRewardsResultSlice'
import dialogRewardsQuestionnaireReducer from '@/features/dialogRewardsQuestionnaireSlice'
import dialogRegisterQuestionnaireReducer from '@/features/dialogRegisterQuestionnaireSlice'
import dialogApplySliceReducer from '@/features/dialogApplySlice'
import authReducer from '@/features/authSlice'
import slideReducer from '@/features/spotMapSlice'
import AsyncThunkSlice from '@/features/apiAsyncSlice'
import accountReducer from '@/features/accountSlice'

export const store = configureStore({
  reducer: {
    dialog: dialogReducer,
    dialogStateQr: dialogReducer,
    stateApiQr: dialogReducer,
    stateKeyWord: dialogReducer,
    dialogStateQrFinish: dialogReducer,
    dialogStateKey: dialogReducer,
    dialogApplyState: dialogApplySliceReducer,
    dialogApplyComfirmState: dialogApplySliceReducer,
    dialogApplyFinishState: dialogApplySliceReducer,
    dialogVisual: dialogVisualReducer,
    dialogStampFinish: dialogStampFinishReducer,
    StampFinish: dialogStampFinishReducer,
    StampPresentState: dialogStampFinishReducer,
    dialogCoupon: dialogCouponReducer,
    dialogGroupSpots: dialogGroupSpotsReducer,
    dialogRewardsGet: dialogRewardsGetReducer,
    dialogRewardsBad: dialogRewardsGetReducer,
    dialogRewardsFinish: dialogRewardsFinishReducer,
    dialogRewardsComfirm: dialogRewardsComfirmReducer,
    dialogRewardsResult: dialogRewardsResultReducer,
    dialogRewardsQuestionnaire: dialogRewardsQuestionnaireReducer,
    dialogRewardsQuestionnaireOnState: dialogRewardsQuestionnaireReducer,
    dialogRewardsQuestionnaireAnswerState: dialogRewardsQuestionnaireReducer,
    dialogRegisterQuestionnaireState: dialogRegisterQuestionnaireReducer,
    slideIndex: slideReducer,
    spotState: slideReducer,
    spotCheck: slideReducer,
    spotWatchid: slideReducer,
    spotCurrentPosition: slideReducer,
    jwttoken: authReducer,
    period: authReducer,
    authAvailable: authReducer,
    loginType: authReducer,
    pageToggle: authReducer,
    campain: AsyncThunkSlice,
    sheets: AsyncThunkSlice,
    account: accountReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export type AppDispatch = typeof store.dispatch
